// extracted by mini-css-extract-plugin
export default {"spacerRow":"AssessmentSummary_spacerRow__9Hobp","detailsTable":"AssessmentSummary_detailsTable__bmTDh"};